import api from './api';

export const GIFT_CARD_STATUSES = ['action_needed', 'sent', 'refunded', 'all'];

export async function getGiftCardRedemptions({ status = 'action_needed', page = 1, limit = 20 } = {}) {
  const params = { page, limit };

  if (status) params.status = status;

  const response = await api.get('/admin/gift-card-redemptions', { params });
  return response.data;
}

export async function getGiftCardRedemptionById(id) {
  const response = await api.get(`/admin/gift-card-redemptions/${id}`);
  return response.data;
}

// action: 'approve' | 'reject'; note is optional (max 500 chars)
export async function reviewGiftCardRedemption(id, { action, note } = {}) {
  const payload = { action };
  if (note) payload.note = note;

  const response = await api.patch(`/admin/gift-card-redemptions/${id}/review`, payload);
  return response.data;
}

// --- Xoxoday provider settings (environment = 'test' | 'live') ---

// Switching tests the target account and reloads the catalog, which can take ~30s.
const XOXODAY_SWITCH_TIMEOUT_MS = 60000;

export async function getXoxodaySettings() {
  const response = await api.get('/admin/xoxoday/settings');
  return response.data;
}

// Send only the fields the admin filled in; omitted fields keep their current value.
export async function updateXoxodayCredentials(environment, payload) {
  const response = await api.put(`/admin/xoxoday/${environment}/credentials`, payload);
  return response.data;
}

export async function testXoxodayConnection(environment) {
  const response = await api.post(`/admin/xoxoday/${environment}/test`);
  return response.data;
}

// 409 (code XOXODAY_SWITCH_CHECK_FAILED) means nothing changed; err.data has the reason.
export async function switchXoxodayEnvironment(environment, { force = false } = {}) {
  const payload = { environment, confirm: true };
  if (force) payload.force = true;

  const response = await api.put('/admin/xoxoday/environment', payload, { timeout: XOXODAY_SWITCH_TIMEOUT_MS });
  return response.data;
}
